(function ($) {
  Drupal.behaviors.astrologyPageTileV1 = {
    attached: false,
    attach: function (context) {
      if (this.attached) {
        return;
      }
      this.attached = true;
      var $thismodule = $('.js-astrology-tile-v1', context);

      $thismodule.each(function () {
        var $module = $(this);
        var $flipCard = $module.find('.astrology-tile__flipcard');
        var $flipCardInner = $module.find('.astrology-tile__flipcard--inner');
        var $popupContainer = $module.find('.astrology-tile__card--popupcontainer');
        var $popupFigure = $module.find('.astrology-tile__popup-figure');
        var $closeButton = $module.find('.astrology-tile__popup-figure--close');
        var $tileVid = $module.find('.astrology-tile__flipcard--inner video');

        $flipCard.once().on('click', function (event) {
          $flipCardInner.removeClass('astrology-tile__embled-hover');
          event.preventDefault();
          $flipCardInner.addClass('active');
          $popupContainer.addClass('visibility');
          $popupContainer.removeClass('removing');
          $popupFigure.addClass('popup-with-anim');
          $popupFigure.removeClass('popup-remove-anim');
          $(window).resize();
        });

        $closeButton.once().on('click', function () {
          $flipCardInner.removeClass('active');
          $popupFigure.removeClass('popup-with-anim');
          $popupFigure.addClass('popup-remove-anim');
          $flipCardInner.addClass('astrology-tile__embled-hover');
          // Animation finished remove classes.
          setTimeout(function () {
            $popupFigure.removeClass('popup-remove-anim');
          }, 700);
          setTimeout(function () {
            $popupContainer.removeClass('visibility');
          }, 700);
          $popupContainer.addClass('removing');
        });

        $(window).on('scroll', _.debounce(function () {
          var top_of_element = $module.offset().top;
          var bottom_of_element = $module.offset().top + $module.outerHeight();
          var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
          var top_of_screen = $(window).scrollTop();

          if (isMobile() && (bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)) {
            // The element is visible.
            var number = 1 + Math.floor(Math.random() * 6);

            if (number % 2 === 0) {
              $tileVid.css({
                'opacity': 1,
                'visibility': 'visible'
              });
            } else {
              $tileVid.css({
                'opacity': 0,
                'visibility': 'hidden'
              });
            }
          }
        }, 600));

        function isMobile() {
          if (Unison.fetch.now().name === 'small') {
            return true;
          }

          return false;
        }
      });
    }
  };
})(jQuery);
